// start:ng42.barrel
import './controllers';
import './directives';
import './person-picker.constants';
import './person-picker.service';
import './person.service';
import './staff.service';
// end:ng42.barrel

